import { Block, Text, Tooltip } from '@upsales/components';
import Client from 'App/resources/Model/Client';
import T from 'Components/Helpers/translate';
import React from 'react';

type Props = Pick<Client, 'operationalAccount'> & { isCompanyColumn?: boolean };

export const SubAccountLabelRaw = ({ operationalAccount, isCompanyColumn }: Props) => {
	if (!operationalAccount) {
		return null;
	}

	if (isCompanyColumn) {
		return (
			<Block borderRadius>
				<Text size="sm" color="grey-11">
					{T('account.subaccount')}
				</Text>
			</Block>
		);
	}

	return (
		<Block space="pls prs mls" backgroundColor="grey-2" borderRadius>
			<Tooltip title={T('account.subaccount.tooltip', { parent: operationalAccount.name })}>
				<Text size="sm" color="grey-12">
					{T('account.subaccount')}
				</Text>
			</Tooltip>
		</Block>
	);
};

const SubAccountLabel = ({ operationalAccount, isCompanyColumn }: Props) => {
	if (!operationalAccount) {
		return null;
	}

	return <SubAccountLabelRaw isCompanyColumn={isCompanyColumn} operationalAccount={operationalAccount} />;
};

export default SubAccountLabel;
